import { PaginatedFieldsContext } from '@cibo/landmanager'
import Addchart from '@mui/icons-material/Addchart'
import { LoadingButton } from '@mui/lab'
import { ButtonProps, Stack, Tooltip } from '@mui/material'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

export const ProfileSelectedFieldsButton = (props: ButtonProps) => {
  const { t } = useTranslation('ProfileSelectedFieldsButton')
  const { onAddInformation, selectedFields, isReady } = useContext(PaginatedFieldsContext)

  return (
    <Stack direction="row" alignItems="center">
      <Tooltip title={t('addInformationTooltip', { count: selectedFields.length })}>
        <span>
          <LoadingButton
            {...props}
            loading={!isReady}
            onClick={onAddInformation}
            startIcon={<Addchart />}
            disabled={selectedFields
              .filter(Boolean)
              .some(
                ({ programStatuses }) =>
                  !programStatuses ||
                  !programStatuses.some(
                    s => s.benchmarks.find(b => b.benchmark === 'profile')?.status === 'incomplete'
                  )
              )}
          >
            {t('addInformation')}
          </LoadingButton>
        </span>
      </Tooltip>
    </Stack>
  )
}
